import React from "react";
import { Div, Button, Text, scrollTo } from "atomize";
import CreatorsModal from "../../modals/CreatorsModal";

class InfluencersJoin extends React.Component {
  // state = { showModal: false };

  render() {
    const { title, label } = this.props;
    return (
      <Div>
        <Div textAlign="center" d="flex" flexDir="column" align="center">
          <Text
            textSize={{ md: "display2", xs: "caption4" }}
            m={{ b: "2rem" }}
            textWeight="700"
            tag="h2"
          >
            {title}
          </Text>
          <Button
            w="14.4rem"
            h="3.125rem"
            bg="primary"
            hoverBg="primary700"
            textColor="black"
            rounded="xs"
            textWeight="700"
            // onClick={() => this.setState({ showModal: true })}
            onClick={() => scrollTo("#creators-hero")}
            fontFamily="secondary"
          >
            {label}
          </Button>
        </Div>
        {/* <CreatorsModal
          isOpen={this.state.showModal}
          onClose={() => this.setState({ showModal: false })}
        /> */}
      </Div>
    );
  }
}

export default InfluencersJoin;
